import { Component, OnInit } from '@angular/core';
import { select, select$ } from '@angular-redux/store';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'mc-recommendation-count',
  templateUrl: './recommendation-count.component.html',
  styleUrls: ['./recommendation-count.component.scss']
})
export class RecommendationCountComponent implements OnInit {
  @select(['recommendationState', 'recommendationCount']) recommendation$: Observable<number>;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/recommendation-count/recommendation-count.component.ts